import { Component, EventEmitter, Input, Output } from "@angular/core";
import { DialogModule } from "primeng/dialog";
import { TableModule } from "primeng/table";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { LoaderService } from "../../../core/services/loader.service";
import { SamplepoSummaryService } from "../../../core/services/samplepo-summary.service";
import { ButtonModule } from "primeng/button";
import { PdfViewerPageComponent } from "../../../shared/components/pdf-viewer-page/pdf-viewer-page.component";

@Component({
  selector: "jni-child-po-confirmation",
  templateUrl: "./child-po-confirmation.component.html",
  styleUrls: ["./child-po-confirmation.component.scss"],
  imports: [DialogModule, TableModule, ButtonModule],
})
export class ChildPoConfirmationComponent {
  @Input() purchaseOrderLine: string[] = [];
  @Input() printPdfModal = false;
  @Output() closePrintPdfModalEvent = new EventEmitter();
  @Output() openPdfScreenModalEvent = new EventEmitter<string>();
  selectedPurchaseOrderLine: string[] = [];

  constructor(
    private _loaderService: LoaderService,
    private _toastr: JniToastrService,
    private _samplePOSummaryService: SamplepoSummaryService
  ) {}

  openPrinfPdfTab() {
    if (
      this.selectedPurchaseOrderLine?.length &&
      this.selectedPurchaseOrderLine?.length === 1
    ) {
      for (const item of this.selectedPurchaseOrderLine) {
        this.openPdfScreen(item || "");
      }
    } else if (
      this.selectedPurchaseOrderLine?.length &&
      this.selectedPurchaseOrderLine?.length > 1
    ) {
      for (const item of this.selectedPurchaseOrderLine) {
        this.onPreview(item);
      }
    }
  }

  closePrinfPdfModal() {
    this.selectedPurchaseOrderLine = [];
    this.closePrintPdfModalEvent.emit();
  }

  openPdfScreen(purchaseOrderId: string) {
    this.onPreview(purchaseOrderId);
  }

  onPreview(purchaseNumber: string) {
    this._loaderService.setLoaderState(true);
    this._samplePOSummaryService
      .getPurchaseOrderConfirmationJournal(purchaseNumber)
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (!res.data) {
            this._toastr.error("Error", res.message);
            return;
          }

          PdfViewerPageComponent.openInNewTab(
            res.data,
            `Nadel-PO# ${purchaseNumber}`
          );

          // const blob = this.b64toBlob(res.data, "application/pdf");
          // const blobUrl = URL.createObjectURL(blob);
          // window.open(blobUrl);
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", "Failed To Load PDF");
        },
      });
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
}
